// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2tu3x","title":"ClientReferral_title__3jAUg","itemText":"ClientReferral_itemText__2xiaR"};